export enum SCREEN_BREAKPOINTS {
    'TINY' = 320,
    'EXTRA_SMALL' = 481,
    'SMALL' = 576,
    'MEDIUM' = 769,
    'LARGE' = 1025,
    'EXTRA_LARGE' = 1200,
}